import React, { useEffect, useState } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Button from "../../Components/common/Button";

import TextField from '../common/TextField';
import Loader from '../../Layout/Loader';
import { checkPrivileges } from '../../Helpers';
import withTranslationWrapper from '../../HOC/HocTranslate';
import { connect } from 'react-redux';
import Table from "../../Components/common/tableWithBackEndPagination";
import ExportFile from '../common/ExportFile';
import { toast } from 'react-toastify';
import instance from '../../axios';
import ConfirmDialoag from '../common/ConfirmDialoag';
import Checkbox from '../common/Checkbox';


const RepeatedDeliveryNotes = (props) => {
  const {
    translate,
    plateNumber,
    searchInvoices,
    getInvoices,
    loader,
    repeatedDeliveryNoteList,
    setRepeatedDnsPagination,
    handleChangePage,
    handleChangeRowsPerPage,
    logInUser,
    goBack,
    to,
    from,
    page,
    limit,
    dispatch
  } = props;
  const [state, setState] = useState({
    isShowChecboxesTable: false,
    selectedIds: [],
    hasToCheckAll: false,
    displayedItems: [],
    visibleCount: 10,
    selectedOptions: [],
    rejectionMessage: '',
  })


  const handleCheckboxClick = (clickedItem) => {
    setState((prevState) => {
      const isAlreadyChecked = prevState.selectedIds.some(item => item.id === clickedItem.id);
      const updatedSelectedIds = isAlreadyChecked
        ? prevState.selectedIds.filter(item => item.id !== clickedItem.id)
        : [...prevState.selectedIds, clickedItem];
      const updatedDisplayedItems = prevState.displayedItems.map(item =>
        item.id === clickedItem.id ? { ...item, checked: !isAlreadyChecked } : item
      );
      const allChecked = updatedDisplayedItems.every(item => item.checked) && updatedDisplayedItems.length > 0;

      return {
        ...prevState,
        selectedIds: updatedSelectedIds,
        displayedItems: updatedDisplayedItems,
        hasToCheckAll: allChecked
      };
    });
  };
  const updateItemsWithCheckedStatus = (newItems) => {
    if(!newItems) return
    const { selectedIds } = state;

    const updatedItems = newItems.map(item => {
      const isChecked = selectedIds.some(selected => selected.id === item.id);
      return { ...item, checked: isChecked };
    });
    setState((prev) => ({
      ...prev,
      displayedItems: updatedItems,
      hasToCheckAll: updatedItems.every(item => item.checked) && updatedItems.length > 0
    }))
  };

  useEffect(() => {
    updateItemsWithCheckedStatus(repeatedDeliveryNoteList?.data)
  }, [repeatedDeliveryNoteList?.data])

  const handleSelectedDn = () => {
    const updatedPageItems = state.displayedItems.map(item => ({
      ...item,
      checked: false
    }));
    setState((prev) => ({
      ...prev,
      isShowChecboxesTable: !prev.isShowChecboxesTable,
      selectedIds: [],
      displayedItems: updatedPageItems,
      hasToCheckAll: false
    }))
  }

  const handleCloseRejectedDnModals = () => {
    setState((prev) => ({
      ...prev,
      isOpenRejectedDnModal: false,
      rejectionMessage: '',
      selectedOptions:[],
    }))
  }

  const handleOpenRejectedDnModals = () => {
    setState((prev) => ({
      ...prev,
      isOpenRejectedDnModal: true
    }))
  }
  const handleLoadMore = () => {
    setState((prevState) => ({
      ...prevState,
      visibleCount: prevState.visibleCount + 10,
    }))
  };

  const handleRejectionMessage = (field, value) => {
    setState((prevState)=>({
      ...prevState,
      [field]: value,
    }))
  };


  const handleCheckboxChange = (option) => {
    setState((prevState) => {
      const selectedOptions = Array.isArray(prevState.selectedOptions)
        ? prevState.selectedOptions
        : [];

      let updatedOptions;
      let updatedMessage = prevState.rejectionMessage || "";

      if (selectedOptions.includes(option.text)) {
        updatedOptions = selectedOptions.filter((item) => item !== option.text);
        const pattern = new RegExp(`\\b${option.text}\\b`, "gi");
        updatedMessage = updatedMessage.replace(pattern, "").replace(/\s+/g, " ").trim();
      } else {
        updatedOptions = [...selectedOptions, option.text];
        updatedMessage = (updatedMessage + " " + option.text).trim();
      }
      return {
        ...prevState,
        selectedOptions: updatedOptions,
        rejectionMessage: updatedMessage,
      };
    });
  };

  const handleSubmitRejectionDns = async () => {
    try {
      const apiPayload = {
        ids:state.selectedIds.map(item => item.id),
        message:state.rejectionMessage,
      };
      const data = await instance.post("/api/deliverynotes/rejectnotes", apiPayload);
      const uncheckedItems = state.displayedItems.map(item => ({
        ...item,
        checked: false,
      }));
setState((prevState)=>({
  ...prevState,
        displayedItems: uncheckedItems,
        selectedIds: [],
        rejectionMessage: '',
        hasToCheckAll: false
}))

props.getRepeatedDns(to,from)
      handleCloseRejectedDnModals()
      toast.success(data)
    } catch (error) {
        let errorMessage=error?.message||"Something went wrong"
      handleCloseRejectedDnModals()
      toast.error(errorMessage)
    }
  };



  const handleAllCheckboxes = (e) => {
    const shouldCheckAll = e.target.checked;
    const allowedItems = state.displayedItems.filter(
      item => item.invoiceMade !== 1 && item.invoiceMade !== 4
    );

    const updatedPageItems = state.displayedItems.map(item => ({
      ...item,
      checked: shouldCheckAll && (item.invoiceMade !== 1 && item.invoiceMade !== 4)
    }));
    const updatedSelectedIds = shouldCheckAll
      ? [
        ...state.selectedIds.filter(
          sel => !state.displayedItems.some(item => item.id === sel.id)
        ),
        ...allowedItems
      ]
      : state.selectedIds.filter(
        sel => !state.displayedItems.some(item => item.id === sel.id)
      );

      setState((prevState)=>({
        ...prevState,
            displayedItems: updatedPageItems,
      selectedIds: updatedSelectedIds,
      hasToCheckAll: shouldCheckAll
      }))
  };







  const formatLabel = (option) => {
    const [firstPart, ...rest] = option.text.split(":");
    return (
      <span>
        <strong>{firstPart}:</strong> {rest.join(":")}
      </span>
    );
  };
   const options = [
      {
        key: "Battery Service with in 365 Days",
        text: translate(
          "Battery Service with in 365 Days"
        ),
      },
      {
        key: "Mileage is wrong in this invoice",
        text: translate(
          "Mileage is wrong in this invoice"
        ),
      },
      {
        key: "Repeated Invoice of same vehicle",
        text: translate(
          "Repeated Invoice of same vehicle"
        ),
      },
        {
        key: "Vehicle not belonged to this account",
        text: translate(
          "Vehicle not belonged to this account"
        ),
      },
           {
        key: "Early service",
        text: translate(
          "Early service"
        ),
      },
           {
        key: "Price Variations",
        text: translate(
          "Price Variations"
        ),
      },
      {
        key: "Other",
        text: translate(
          "Other"
        ),
      }
    ];
  return (
    <Grid>
      <Grid container className="breadcrumb-row" style={{ paddingLeft: 10, paddingRight: 10 }}>
         <Grid item xs={12} sm={3} justifyContent={"space-between"}>
          <h3 style={{ margin: 0 }}>{translate("allDubiousDnNotes")}</h3>
           {
                  state.isShowChecboxesTable&&state.selectedIds?.length>0&&
                                              <Button
                      aria-label="search"
                      size="small"
                      color="inherit"
                      onClick={handleOpenRejectedDnModals}
                      id="search"
                    >
                    {translate("reject dns")}  ({state.selectedIds?.length > 99 ? '99+' : state.selectedIds?.length})
                    </Button> 
                  }
        </Grid>
        <Grid item xs={12} sm={9} style={{ justifyContent: "flex-end" }}>


          <div style={{ width: "25%", marginRight: 20 }}>
            <TextField
              fullWidth
              label={translate("plateNumber")}
              value={plateNumber}
              onChange={(e) => searchInvoices(e, "plateNumber")}
            />
          </div>
          <Button aria-label="search" size="small" color="inherit" onClick={getInvoices} style={{ marginRight: 20 }}>
            {translate("search")}
          </Button>
           <Button
                      aria-label="Show"
                      size="small"
                      color="inherit"
                      onClick={handleSelectedDn}
                      id="search"
                      style={{margin:20}}
                    >
                      {state.isShowChecboxesTable?translate("unSelect"):translate("Select")}
                    </Button>
          {/* <ExportFile
            title={translate("export")}
            fileName="wrongMileage"
            downloadType="wrongMileage"
            translate={translate}
            dataLength={
              repeatedDeliveryNoteList?.data && repeatedDeliveryNoteList?.data?.length ? true : false

            }
            dispatch={dispatch}
            from={from}
            to={to}
            page={page}
            limit={1000}
          /> */}

          <Button
            aria-label="Back"
            size="small"
            color="inherit"
            onClick={goBack}
            style={{ margin: 10 }}
          >
            {translate("sharedBack")}
          </Button>
        </Grid>
      </Grid>

      <Grid>
        {loader ? <Loader /> : (
          <Table
                   hasToCheckAll={state.hasToCheckAll}
                  rows={(state.displayedItems) || []}
            pagination={setRepeatedDnsPagination()}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            isEditable
            canUpdate
            canDelete
                              isDeliveryNotes={true}
       multiSelect={state.isShowChecboxesTable}
       handleCheckboxClick={handleCheckboxClick}
       handleAllCheckboxes={handleAllCheckboxes}
            // onEdit={onEdit}
            // onDelete={onDelete}
            // themecolors={themecolors}
            serverTimezone={logInUser?.attributes?.timezone || "Asia/Riyadh"}
            timezone={logInUser?.attributes?.timezone || "Asia/Riyadh"}
            // hasAccessOfUpdate={
            //   value === "cashCustomer" ? checkPrivileges("cashinvoiceUpdate") : ""
            // }
            // contractNumber={selectedAccount?.contractNumber || ""}
            // invoiceType={value}
            // downloadInvoice={downloadInvoice}
            // regenerateInvoice={regenerateInvoice}
            // leasing={leasing}
            invoiceRow
            isSelectedDubious={props.isSelectedDubious}
            rowDefinition={[
              {
                id: "deliveryNoteNumber",
                numeric: false,
                disablePadding: false,
                label: props.translate("deliveryNoteNo"),
              },
              {
                id: "deliveryNoteRefNumber",
                numeric: false,
                disablePadding: false,
                label: props.translate("deliveryNoteRefNumber"),
              },
              {
                id: "serviceId",
                numeric: false,
                disablePadding: false,
                label: props.translate("bookingID"),
              },
              {
                id: "workOrderNumber",
                numeric: false,
                disablePadding: false,
                label: props.translate("workOrderNumber"),
              },
              {
                id: "serviceRefNumber",
                numeric: false,
                disablePadding: false,
                label: props.translate("customerRefNum"),
              },
              {
                id: "plateNumber",
                numeric: false,
                disablePadding: false,
                label: props.translate("vehicleLicensePlate"),
              },
              {
                id: "serviceDate",
                numeric: false,
                disablePadding: false,
                label: props.translate("serviceDate"),
              },
              {
                id: "saleTotalAmount",
                numeric: false,
                disablePadding: false,
                label: props.translate("Amount"),
              },
              {
                id: "saleVATAmount",
                numeric: false,
                disablePadding: false,
                label: props.translate("VAT Amount"),
              },
              {
                id: "saleNetAmount",
                numeric: false,
                disablePadding: false,
                label: props.translate("Total Amount"),
              },
              {
                id: "odometerReading",
                numeric: false,
                disablePadding: false,
                label: props.translate("odometerReading"),
              },

              {
                id: "creationMode",
                numeric: false,
                disablePadding: false,
                label: props.translate("creationMode"),
                hide: checkPrivileges("invoiceInvalidView")
                  ? false
                  : true,
              },
              {
                id: "valid",
                numeric: false,
                disablePadding: false,
                label: props.translate("status"),
                hide: checkPrivileges("invoiceInvalidView")
                  ? false
                  : true,
              },
              {
                id: "viewDeliveryNote",
                numeric: false,
                disablePadding: false,
                label: props.translate("viewDeliveryNote"),
                hide: false,
              },
            ]}
          />
        )}
      </Grid>

      {state.isOpenRejectedDnModal && (
                  <ConfirmDialoag
                    onCancel={handleCloseRejectedDnModals}
                    onOk={handleSubmitRejectionDns}
                    title={translate('rejectedDns')}
                    maxWidth={"lg"}
                  >
                    <>
<Box sx={{ maxHeight: 400, overflowY: 'auto', border: '1px solid #ccc', borderRadius: 2, p: 2, width: "800px" }}>
  <Stack direction="row" spacing={2} sx={{ mb: 1, fontWeight: 'bold', borderBottom: '1px solid #ddd', pb: 1 }}>
    <Box sx={{ width: '50%' }}>Delivery Note Number</Box>
    <Box sx={{ width: '50%' }}>Total Amount</Box>
  </Stack>
  {state.selectedIds?.length > 0 ? (
    <>
      {state.selectedIds.slice(0, state.visibleCount).map((item, index) => (
        <Stack
          key={item.id || index}
          direction="row"
          spacing={2}
          sx={{
            mb: 1,
            '&:hover': { backgroundColor: '#f5f5f5' },
            borderBottom: '1px solid #eee',
            py: 1,
          }}
        >
          <Box sx={{ width: '50%' }}>{item.deliveryNoteNumber}</Box>
          <Box sx={{ width: '50%' }}>{item?.saleNetAmount||0}</Box>
        </Stack>
      ))}

{state.selectedIds?.length > state.visibleCount ? (
  <Box textAlign="center" mt={2}>
    <Button variant="outlined" onClick={handleLoadMore}>
      Load More
    </Button>
  </Box>
) : (
  state.selectedIds?.length > 0 && (
    <Box textAlign="center" mt={2}>
      <Typography variant="body2" color="text.secondary">
        End
      </Typography>
    </Box>
  )
)}

    </>
  ) : (
    <Typography variant="body2" color="text.secondary">
      No delivery notes selected.
    </Typography>
  )}
</Box>
<Grid item md={12}>
                  {options.map((option) => (
                    <Grid item xs={12} key={option.key} sx={{ mb:1}} >
                      <div style={{display:"flex",alignItems:"start"}}>

            <Checkbox
            checked={state.selectedOptions?.includes(option.text)}
            onChange={() =>handleCheckboxChange(option)}
            label={formatLabel(option)}
             color="primary"
             />
             </div>
        </Grid>
      ))}
</Grid>
  <Grid item md={12}>
                    <TextField
                      id="message"
                      multiline
                      label={translate("message")}
                      placeholder=""
                      value={state.rejectionMessage || ""}
                      onChange={(e) =>
                        handleRejectionMessage("rejectionMessage", e.target.value)
                      }
                      variant="outlined"
                      margin="dense"
                      fullWidth
                   sx={{
    '& .MuiOutlinedInput-root': {
      padding: 0,
    },
  }}
                    />
                  </Grid>
                    </>


                  </ConfirmDialoag>)}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export default connect(mapStateToProps)(
  withTranslationWrapper(RepeatedDeliveryNotes)
);
